import React from 'react';
import { useOnlineStatus } from 'Hooks/useOnlineStatus';
import Alert from '@mui/material/Alert';
import Box from '@mui/material/Box';

export default function OfflineBanner() {
  const isOnline = useOnlineStatus();

  if (isOnline) {
    return null;
  }

  return (
    <Box sx={{ width: '100%', position: 'fixed', top: 0, left: 0, zIndex: 9999 }}>
      <Alert severity='warning' sx={{ borderRadius: 0 }}>
        You are offline. Some features may not be available.
      </Alert>
    </Box>
  );
}
